import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ConnectionsOperations from './ConnectionsOperations';
import { fetchConnections, fetchConnection } from 'redux/connections/ConnectionsActions';

const mapStateToProps = ({ connections }) => ({
  fetchingConnections: connections.fetchingConnections,
  connections: connections.connections
});

const mapDispatchToProps = dispatch => ({
  connectionsActions: bindActionCreators({ fetchConnections, fetchConnection }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ConnectionsOperations);



// WEBPACK FOOTER //
// ./src/components/manageConnection/comp/connectionsOperations/ConnectionsOperationsConnector.js